// Alpine
import Alpine from 'alpinejs'

// Add to window
window.Alpine = Alpine;